import { CriticalButtonStructure } from "./Variants/Critical/styles";
import { InfoButtonStructure } from "./Variants/Info/styles";
import { LightButtonStructure } from "./Variants/Light/styles";
import { PrimaryButtonStructure } from "./Variants/Primary/styles";
import { SecondaryButtonStructure } from "./Variants/Secondary/styles";
import { SuccessButtonStructure } from "./Variants/Success/styles";
import { TertiaryButtonStructure } from "./Variants/Tertiary/styles";
import { WarningButtonStructure } from "./Variants/Warning/styles";

import styled, { css } from "styled-components";

const gap = ({ size }) => {
  switch (size) {
    case "xs":
      return "4px";

    case "sm":
    case "lg":
    default:
      return "8px";
  }
};

const borderRadius = ({ size }) => {
  switch (size) {
    case "xs":
    case "sm":
      return "4px";

    case "lg":
    default:
      return "8px";
  }
};

const padding = ({ size, $outline }) => {
  switch (size) {
    case "xs":
      return $outline ? "2px 8px" : "4px 8px";
    case "sm":
      return $outline ? "6px 14px" : "8px 14px";
    case "lg":
      return $outline ? "14px 24px" : "16px 24px";

    default:
      return $outline ? "10px 20px" : "12px 20px";
  }
};

const customStyles = ({ width, padding, margin, gridArea, border }) => {
  let customStyles = "";

  if (width) customStyles += `width: ${width} !important;`;
  if (padding) customStyles += `padding: ${padding};`;
  if (margin) customStyles += `margin: ${margin};`;
  if (gridArea) customStyles += `grid-area: ${gridArea};`;
  if (border) customStyles += `border: ${border};`;

  return css`
    ${customStyles}
  `;
};

const variantStyles = ({ $variant }) => {
  switch ($variant) {
    case "primary":
    default:
      return PrimaryButtonStructure;
    case "secondary":
      return SecondaryButtonStructure;
    case "tertiary":
      return TertiaryButtonStructure;
    case "critical":
      return CriticalButtonStructure;
    case "warning":
      return WarningButtonStructure;
    case "info":
      return InfoButtonStructure;
    case "success":
      return SuccessButtonStructure;
    case "light":
      return LightButtonStructure;
  }
};

export const ButtonStylesStructure = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${gap};
  /* border-radius: ${borderRadius}; */
  padding: ${padding};
  ${({ theme, size }) => theme.font.body[size]}
  height: fit-content;

  transition: 0.2s;

  &:disabled {
    opacity: 0.2;
    cursor: not-allowed;
  }

  ${variantStyles}
  ${customStyles}
`;
